module.exports = __webpack_public_path__ + "static/media/franciscan-life-2022.970d3ef7.jpg";